import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getEmployeeToken } from '../utils/employeeApi';

const EmployeeProtectedRoute = () => {
  const token = getEmployeeToken();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/employee/mobile/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default EmployeeProtectedRoute;
